import { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Button, Columns, LoadingModule, SaveFormModule,
} from '@domain-group/suit-theme'

import useOrderBundle, { useOrderBundleForm } from '@hooks/useOrderBundle'

import PageContext from '@contexts/pageContext'

import OrderBundleTools from '../../../../components/OrderBundleTools'
import PageLayout from '../../../../components/PageLayout'

import OrderBundleAgencies from '../OrderBundleAgencies'
import OrderBundleDetails from '../OrderBundleDetails'
import OrderBundleProducts from '../OrderBundleProducts'
import OrderBundleSettings from '../OrderBundleSettings'

const PageContent = (props) => {
  const { orderBundleId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateOrderBundle,
    },
  } = pageContext

  const orderBundlePayload = useOrderBundle({ id: orderBundleId })
  const {
    callbacks: {
      updateOrderBundle: updateFn,
    },
    loading,
    orderBundle,
    updating,
  } = orderBundlePayload

  const orderBundleFormPayload = useOrderBundleForm(orderBundle)
  const { entityState, saveEnabled } = orderBundleFormPayload

  const updateOrderBundlePayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Order Bundle Updated',
  }

  return (
    <PageLayout entityPayload={orderBundlePayload}>
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <OrderBundleDetails orderBundleFormPayload={orderBundleFormPayload} />

            <OrderBundleProducts orderBundleId={orderBundleId} />

            <OrderBundleAgencies orderBundleId={orderBundleId} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                marginLeft="auto"
                onClick={() => updateOrderBundle(updateOrderBundlePayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <OrderBundleTools
          orderBundlePayload={orderBundlePayload}
          updateOrderBundle={updateOrderBundle}
        />

        <OrderBundleSettings
          orderBundleFormPayload={orderBundleFormPayload}
          orderBundlePayload={orderBundlePayload}
        />
      </Columns.Sidebar>
    </PageLayout>
  )
}

PageContent.propTypes = {
  orderBundleId: PropTypes.number.isRequired,
}

export default PageContent
